<template>
  <page
    title="Nek"
    class="complaint"
    :image="{
      src: '/assets/img/body_parts/Nek_m.jpg',
      alt: 'Nek',
    }"
    :page-menu-items="menu_items"
  >
    <complaint
      title="Nek"
      image="/assets/img/body_parts/Nek_m.jpg"
      :employees="['Mario', 'Lars']"
      :gradient="true"
    >
      <p>
        De cervicale wervelkolom (de nek) bestaat uit 7 halswervels welke in de
        fysiotherapie aangeduid worden met de letter C (C1 tot en met C7). De
        bovenste twee wervels (C1 en C2) zijn bijzondere wervels met een unieke
        unieke vorm. De stand van de gewrichtsvlakjes waarmee de wervels
        onderling met elkaar zijn verbonden is vrij vlak, waardoor in dit
        gedeelte van de wervelkolom de meeste bewegingsmogelijkheden bestaan. De
        meeste klachten ontstaan laag in de cervicale wervelkolom tussen
        niveau’s C5 t/m C7. De manueel therapeut kan deze klachten vaak goed
        verhelpen.
      </p>
    </complaint>
    <complaint v-for="item in items" :title="item.title" v-bind:key="item.key">
      <p v-for="text in item.text" v-bind:key="text.key">
        {{ text }}
      </p>
    </complaint>
  </page>
</template>

<script>
import Page from "@/layout/page.vue";
import Complaint from "@/components/sections/complaint.vue";

import { titleToId } from "@/utilities.js";

export default {
  name: "Nekklachten",
  head: {
    title: "Faam | Nekklachten",
    meta: [
      {
        name: "description",
        content: `Vind verlichting voor uw nekklachten bij Faam Fysiotherapie in Uden.
                  Onze ervaren therapeuten bieden gespecialiseerde behandelingen om pijn te
                  verminderen en mobiliteit te verbeteren. Ontdek hoe wij u kunnen helpen bij
                  het herstel van nekklachten.`,
      },
    ],
  },
  components: {
    Page,
    Complaint,
  },
  data() {
    return {
      items: [
        {
          title: "Artrose",
          text: [
            `Wanneer men ouder wordt vindt er een natuurlijke degeneratie plaats van
            de cervicale wervelkolom. Een diagnose kan alleen aan de hand van een
            röntgenfoto worden gesteld. Het klachtenpatroon dat kan optreden is vaak
            niet anders dan bij a-specifieke nekklachten. Er is echter geen
            duidelijke correlatie te vinden tussen nekklachten en nek artrose. Zo
            worden er al degeneratieve veranderingen in de gewrichten in de
            wervelkolom bij de helft van de 50-jarigen gevonden in röntgenfoto’s,
            terwijl zij lang niet allemaal ook nekklachten hebben.`,
          ],
        },
        {
          title: "A-specifieke nekklachten",
          text: [
            `A-specifieke nekklachten zijn nekklachten waarbij geen aanwijzingen
            kunnen worden gevonden voor beschadiging van structuren in de nek. Vaak
            is er ook geen duidelijke oorzaak als verklaring voor het ontstaan
            ervan. Het ontstaansmechanisme heeft meestal te maken met acute of
            chronische overbelasting van de cervicale wervelkolom en zijn
            structuren. Bij nekpijn is het veelal zinvol om te beter te begrijpen
            hoe het achterliggende pijnmechanisme werkt. De fysiotherapeut bespreekt
            dit graag met u en legt u graag uit hoe nekpijn ontstaat. Vaak ervaart
            men bij a-specifieke nekklachten stijfheid in de spieren in de nek en
            kan men de nek minder goed bewegen in bepaalde richtingen. Ook kunnen
            klachten soms doorstralen naar de schouder en/of arm.`,
          ],
        },
        {
          title: "Cervicale facetirritatie",
          text: [
            `Cervicale facetirritatie is een aandoening die pijn en ongemak
            veroorzaakt in de nek door irritatie van de facetgewrichten. Deze kleine
            gewrichten bevinden zich tussen de wervels van de nek (cervicale
            wervelkolom) en spelen een cruciale rol bij de stabiliteit en
            beweeglijkheid van de cervicale wervelkolom. De symptomen van cervicale
            facetirritatie kunnen variëren, maar de meest voorkomende zijn: nekpijn,
            stijfheid, hoofdpijn en referred pain (verplaatste pijn naar het hoofd,
            de schouders of de armen).`,
          ],
        },
        {
          title: "Cervicale radiculopathie",
          text: [
            `Een cervicaal radiculair syndroom is een verzamelnaam van klachten die
            ontstaan door beklemming van een of meerdere zenuwwortels in de nek.
            Deze zenuwwortels komen uit de ruggenmerg en lopen via de wervelkolom
            naar buiten richting de nek en arm. Een zenuw kan om uiteenlopende
            redenen ontstoken raken en kan in zijn verloop naar buiten beklemt
            worden waardoor er compressie ontstaat op de zenuwwortel. De meest
            voorkomende en bekendste oorzaak van een beklemming van de zenuwwortel
            is een nekhernia. Daarbij stulpt een tussenwervelschijf (een soort
            kussentje tussen de ruggenwervels) uit, en kan compressie geven op een
            zenuwwortel. De klachten die kunnen ontstaan zijn nekklachten en
            uitstralende pijn richting de arm die vaak omschreven worden als scherp,
            schietend of snijdend. Ook kan er een doof gevoel, tintelingen en
            krachtsverlies in de nek, schouder en/of arm optreden. Vaak wordt de
            pijn in de armen erger ervaren als de pijn in de nek.`,
          ],
        },
        {
          title: "Nekklachten en hoofdpijn",
          text: [
            `Nekklachten komen soms ook voor in combinatie met hoofdpijn. Zo kunnen
            nekklachten aan de hand van verhoogde spierspanning in de nek en stress
            uitstralen naar het hoofd. Dit wordt spanningshoofdpijn (Tension-type
            headache) genoemd. Deze hoofdpijn kenmerkt zich door pijn aan beide
            zijdes van het hoofd en heeft vaak een bedrukkende, niet pulserende
            aard. Deze hoofdpijn komt vaak voor in episodes of voor langere periode
            aan een stuk. Dit is de meest voorkomende soort hoofdpijn die in
            combinatie met nekpijn voorkomt.`,
            `Een andere vorm van hoofdpijn die kan voorkomen bij nekklachten is
            cervicogene hoofdpijn. Deze hoofdpijn komt voort vanuit een
            bewegingsbeperking hoog in de cervicale wervelkolom. Waar klachten laag
            in de cervicale wervelkolom uitstralen richting de armen, stralen deze
            klachten uit naar het hoofd. De klachten uiten zich meestal eenzijdig
            van het hoofd, net boven het kaakgebied, en zijn niet pulserend van
            aard. Ook straalt de pijn uit in de nek/schouder aan de zelfde kant als
            de hoofdpijn zich uit. Soms is deze hoofdpijn moeilijk te onderscheiden
            van migraine en cluster hoofdpijn.`,
          ],
        },
        {
          title: "Whiplash Associated Disorder (WAD)",
          text: [
            `Whiplash Associated Disorder (WAD) is een term die gebruikt wordt om een
            reeks symptomen te beschrijven die optreden na een plotselinge, snelle
            beweging van het hoofd en de nek, zoals bij een botsing met de auto.
            Deze beweging kan schade veroorzaken aan de spieren, ligamenten, zenuwen
            en andere weefsels in de nek. De meest voorkomende oorzaak van WAD is
            een auto-ongeluk waarbij de nek een plotselinge slingerbeweging maakt.
            Andere mogelijke oorzaken zijn: vallen, sportblessures of andere
            trauma’s waarbij de nek een snelle en abrupte beweging maakt. Symptomen
            van WAD kunnen direct na het trauma optreden, maar soms ook pas na
            enkele uren of dagen. De meest voorkomende symptomen zijn: nekpijn en
            stijfheid, hoofdpijn, schouder- en rugpijn, duizeligheid, tintelingen en
            gevoelloosheid, vermoeidheid, concentratieproblemen en geheugenverlies.`,
          ],
        },
      ],
    };
  },
  computed: {
    menu_items() {
      return this.items.map((item) => {
        return {
          title: item.title,
          url: `#${titleToId(item.title)}`,
        };
      });
    },
  },
};
</script>

<style lang="less">
.complaint {
  section {
    &:not(:last-child):not(:first-child):not(:nth-child(2)) {
      border-bottom: 1px solid #4e4d4d;
    }
  }
}
</style>
